window.featureFlags = {flagValues: {}};
featureFlags.set = function(key, value) {
        return featureFlags.flagValues[key] = value;
}
featureFlags.get = function(key) {
        return featureFlags.flagValues[key];
}

function trace(message) {
    if (console) {
        console.log(message);
    }
}

function isValidGuid(id)
{
    var newPattern = /^[a-fA-F0-9]{8}(-|_)[a-fA-F0-9]{4}(-|_)[a-fA-F0-9]{4}(-|_)[a-fA-Z0-9]{4}(-|_)[a-fA-F0-9]{12}$/i;
    var oldPattern = /^[a-fA-F0-9]{32}$/i;
    return newPattern.test(id) === true || oldPattern.test(id) === true;
}

function incrementMetric(feature, key){
    console.log('Metric++ ' + feature + ' - ' + key);
    var environment = guessEnvironment();
    var url = 'https://yardstick.bombbomb.io/feature/' +feature +'/' +key +'/increment';
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        mode: 'cors',
        async: false,
        body: JSON.stringify({environment: environment,  xsrc: 'app'})
    }).catch(function(error) {
        console.error(error);
    });
}

function showAbuseLockdownNotificationOnClick(){
    $.notify.warning('<h3 align="center">Please contact support to unlock your account.</h3>');
}

function fillSelectBoxWithTags(selectBoxSelector, catchAllDisplayName, alternateUserId) {

    if (catchAllDisplayName == null) {
        catchAllDisplayName = 'My Stuff';
    }

    var select = $(selectBoxSelector);

    select.empty();

    function addChildren(depth, tags) {

        var indentPart = '&nbsp;&nbsp;&nbsp;';
        var indent = '';
        for (var i = 0; i<depth; i++) {
            indent += indentPart;
        }

        if (depth > 0) {
            indent += ' - ';
        }

        for (i = 0; i<tags.length; i++) {
            var tag = tags[i];
            var displayName = tag.name;
            if (tag.context == 'CATCHALL') {
                displayName = catchAllDisplayName;
            }
            select.append("<option value='" + tag.id + "'>" + indent + displayName + "</option>");
            addChildren(depth + 1, tag.childTags);
        }
    }

    var parameters = {mime:'json'};
    if (null != alternateUserId) {
        parameters.userId = alternateUserId;
    }
    bbApiCallWithCallback('GetUserTagHierarchy', parameters, function(wrapper) {
        var tags = wrapper.info;
        addChildren(0, tags);
    });
}

function valid_email(email) {
	var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return email.match(re);
}

function el( id ) {
  if ( document.getElementById )
    return document.getElementById( id );
  else if ( window[id] )
    return window[id];
  return null;
}

function show_el( id ) {
	el(id).style.display='';
}

function hide_el( id ) {
	el(id).style.display='none';
}

function clog(msg) {
	var logger=0;
	var browser=navigator.appName;
	if (logger) {
		trace(msg);
	}
}

/**
 * Deprecated: Use bbLogWithFetch instead from
 * www/react/functions/bbLogWithFetch.js
 */
function bbLog(message, details, severity, logchainid, feature){
    console.info(
      'deprecated use of "bbLog", please use bbLogWithFetch instead.',
      'See www/react/functions/bbLogWithFetch.js'
    );
    var environment = guessEnvironment();
    var body = JSON.stringify({message: message, details:details, severity: severity, logchainid: logchainid, feature: feature, xsrc: 'app', environment: environment });
    $.post("https://lumberjack.bombbomb.io", body);
}

function guessEnvironment() {
    var environment = 'PROD';

    if (document && document.location && document.location.href) {
        var match = document.location.href.match(/\/\/([^.]+)[.]/);
        if (match && match[1]) {
            var subdomain = match[1].toUpperCase().replace('-VIEW', '');
            if (subdomain.match(/^DEV|LOCAL|STAGE|QA$/)) {
                environment = subdomain;
            }
        }
    }

    return environment;
}

function bbApiCall(method, parameters){
    bbApiCallWithCallback(method, parameters, null);
}

function bbApiCallWithCallback(method, parameters, onSuccess, onFail){
    $.post("/app/api/api.php?method=" + method, parameters, function(data) {
        try {
            if (onSuccess != null) onSuccess(data);
        } catch(e) {
            console.log(e);
        }
    })
    .fail(function(e) {
        if (onFail != null && typeof onFail == 'function') {
            onFail(e.responseText);
        }
    });
}

function bbApiCallSychronous(method, parameters){
    var result = null;
    $.ajax({
        url: "/app/api/api.php?method=" + method,
        type: 'post',
        parameters: parameters, // TODO: Do wee need the "parameters" option?  Not sure it is being used.
        data: parameters,
        async: false,
        success: function(data) {
            result = data;
        }
    });
    return result;
}

function centerElement(element) {
    var $element = $(element);
    var $window = $(window);
	var popupLeftPos = ($window.width() - $element.width()) / 2;
	var popupTopPos = ($window.height() - $element.height()) / 2;

	$(element).css('left', popupLeftPos);
	$(element).css('top', popupTopPos);
}

var popupFrameAnimIntervalId = null;
function bbPopup(url, width, height, topHtml, options, matchScrollTop, onCloseCallback) {

    var bbPopupFrameHTML = "<span class='bb_popup_frame_loader'><img src='/app/images/loading.gif' /></span><iframe mozallowfullscreen webkitallowfullscreen allowfullscreen id='bb_popup' class='bb_popup_frame' frameborder='0' src='" + url.replace(/'/g, "%27") + "'></iframe>";
    bbHTMLPopup(bbPopupFrameHTML, width, height, topHtml, onCloseCallback, options, matchScrollTop);

    $('.bb_popup_frame').on('load', function() {
        $('.bb_popup_frame_loader').remove();
    });
}

function responsiveIframePopup(url, overrideClass) {
    overrideClass = overrideClass || '';

    var responsiveModalGeneral = $('#responsive-modal-iframe');
    responsiveModalGeneral.removeClass();
    $("body").addClass("bb-responsive-modal-open");
    responsiveModalGeneral.addClass('responsive-modal ' + overrideClass);
    $('#responsive-modal-iframe iframe').attr('src', url);

    $('iframe').on('load', function() {
        resizeIframe();
        window.location.hash = 'responsive-modal-iframe';
    });

    $(window).resize(function(){
        resizeIframe();
    });
}

function resizeIframe() {
    $('#responsive-modal-iframe iframe').contents().find("head").append($("<style type='text/css'> html, body{height:auto !important;}  </style>"));
    $('#responsive-modal-iframe iframe').css("height", $('#responsive-modal-iframe iframe').contents().find("html").height() + 'px');
}

function responsivePopup(content, overrideClass) {
    overrideClass = overrideClass || '';

    var responsiveModalGeneral = $('#responsive-modal-general');
    responsiveModalGeneral.removeClass();
    $("body").addClass("bb-responsive-modal-open");
    responsiveModalGeneral.addClass('responsive-modal ' + overrideClass);
    $('.main-block', responsiveModalGeneral).html(content);

    window.location.hash = 'responsive-modal-general';
}

var onbbHtmlPopupCloseCallback = null;

function bbHTMLPopup(html, width, height, topHtml, onCloseCallback, options, matchTopScroll) {
    matchTopScroll = matchTopScroll || false;

    var settings = $.extend({
        'popupCssClass': null,
        'popupStyle': null,
        'closeButtonStyle': null,
        'closeButtonImgSrc': null,
        'minPopupPadding': 100
    }, options);

    onbbHtmlPopupCloseCallback = onCloseCallback;

    var bg = $("<div class='bb_popup_bg' id='bb_popup_bg'></div>");

	var box = $("<div class='bb_popup' id='bb_popup_box'></div>");
    var closeButtonImg = $("<img src='/app/images/modules/onboarding/icon-close.svg' />");
    var closeButton = $("<a href='javascript:void(0)' style='float:right;' onclick='onbbHtmlPopupClose()' class='bbPopupCloseButton'></a>").append(closeButtonImg);
	box.append(closeButton);
    box.append("<div id='bb_popup_notifications'></div>");

	if (topHtml != null){
		box.append($(topHtml));
    }

	box.append(html);

     if (width != undefined) {
        var winWidth = $(window).width();
        if (width > winWidth - settings.minPopupPadding)
            width = winWidth - settings.minPopupPadding;
        box.css('width', width);
    }

    if (height != undefined) {
        var winHeight = $(window).height();
        if (height > winHeight - settings.minPopupPadding)
            height = winHeight - settings.minPopupPadding;
        box.css('height', height);
    }

	$('body').append(bg).append(box);

	centerElement(box);

    if (settings.popupCssClass != null)
    {
        box.attr("class", box.attr("class") + " " + settings.popupCssClass);
    }
    if (settings.popupStyle != null)
    {
        box.css(settings.popupStyle);
    }

    if (matchTopScroll) {
        var scrollTop = $(window).scrollTop();
        var currentTop = parseInt(box.css('top'), 10);
        box.css('top', currentTop + scrollTop);
    }

    if (settings.closeButtonStyle != null)
    {
        closeButton.css(settings.closeButtonStyle);
    }

    if (settings.closeButtonImgSrc != null)
    {
        closeButtonImg.attr('src', settings.closeButtonImgSrc);
    }

	box.fadeIn();
}

function onbbHtmlPopupClose()
{
    killAllbbPopups();
    if (onbbHtmlPopupCloseCallback) onbbHtmlPopupCloseCallback();
}

function killAllbbPopups() {
	$('.bb_popup, .bb_popup_bg').fadeOut(500, function(){
        $('.bb_popup, .bb_popup_bg').not('.bbng_popup').remove();
	});
}

function format_number(nStr, decimals)
{
	nStr += '';
	x = nStr.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}

    if (x2.length > 0 && decimals != null) {
        if (decimals == 0) x2 = '';
        var missing_zeros = decimals - x[1].length;
        for (var zero_loop = 0; zero_loop < missing_zeros; zero_loop++)
            x2 = x2 + '0';
    }

	return x1 + x2;
}


function send_email_to_emailaddress(email_id, email_address) {
	$.get(getAppUrl() + "?module=emails&actn=send_email_to_emailaddress&email_id=" + email_id + "&email_address=" + encodeURIComponent(email_address), function() {
		alert('Email queued for delivery.');
	});
}

function send_drip_to_emailaddress(drip_id, email_address) {
	$.get(getAppUrl() + "?module=drips&actn=add_emails_to_drip&email_addresses=" + encodeURIComponent(email_address) + "&drip_id=" + drip_id, function() {
		$('body').trigger('needRefresh');
	});
}

function bbEmailWindow(email_id) {
	bbPopup(getAppUrl() + "?module=emails&popup=1&page=miniSend&e=" + encodeURIComponent(email_id), 500, 550);
}

function bbContactEditor(contact_id) {
	bbPopup(getAppUrl() + '?module=lists&page=edit&id=' + contact_id + '&popup=1', 850, '90%');
}

function parentRefresh() {
	try {
		$('body').trigger('ParentRefresh');
	} catch(e) {}
}

function findUrls(html) {

    if (!(html)){
        return;
    }

    html = html.replace(/<img[^>]*>/g,""); //images were loaded in the bg and cause issues, this removes imgs

    var list = [];

    try {
        $('a', html).each(function() {
            var href = $(this).attr('href');

            //Make sure there's a url to work with, otherwise don't push it.
            if (href != null){
                if (href.indexOf('mailto:') == 0) return;

                var text = $(this).text();
                list.push({label: text, url: href});
            }
        });

        $('map area', html).each(function() {
            var href = $(this).attr('href');
            var alt = $(this).attr('alt');

            if (href.indexOf('mailto:') == 0) return;

            list.push({label: alt || href, url: href});
        });
    } catch(e) {  }

    return list;
}

function getAppUrl() {
    var root = app_url;
    if (window.location.protocol == "https:") {
        root = root.replace("http://", "https://");
    } else {
        root = root.replace("https://", "http://");
    }
    return root;
}

function rigLinkAlertsTable() {

    //trim out empty string urls
    if ($.inArray('', alertLinkUrls) != -1)
        alertLinkUrls.splice($.inArray('', alertLinkUrls),1);

    var urls = findUrls(getEditorEmailHtml());

    if ((!(urls) || (urls.length == 0))) {
        return;
    }

    $('#linkAlertTable').empty();
    $(urls).each(function(){
        var url = this.url;
        var label = this.label;

        var div = $('<div class="checkboxInputs"></div>');
        var checkedHtml = $.inArray(url, alertLinkUrls) != -1 ? " checked='checked'" : "";
        var linkCheckbox = $('<input type="checkbox" value="' + url + '" ' + checkedHtml + ' />');
        var linkUrl = $('<label>"' + label + '" link is clicked<span class="small">' + url + '</span></label>');

        div.append(linkCheckbox).append(linkUrl);

        $('#linkAlertTable').append(div);
    });
}

function alertLinkSelectionChanged(url, checked) {

    if (checked) {
        if ($.inArray(url, alertLinkUrls) == -1)
            alertLinkUrls.push(url);
    } else {
        alertLinkUrls.splice($.inArray(url, alertLinkUrls),1);
    }
}

function centerPopup(popup_id) {
    var signupLeftPos = (window.innerWidth - $('#' + popup_id).width()) / 2;
    var signupTopPos = (window.innerHeight - $('#' + popup_id).height()) / 2;

    $('#' + popup_id).css('left', signupLeftPos);
    $('#' + popup_id).css('top', signupTopPos);

    $('#' + popup_id).fadeIn();

}

var lastSearchResult = null;
var lastSearchMaxedOut = false;
var suggestionLastSearched = '';
var suggestionWaitingOnApi = false;

function popupVideo(id) {
    getVideoMetaData(id, function(data){
        bbPopup('/app/?module=videos&page=preview&popup=1&nohtml=1&id=' + id, parseInt(data.width), parseInt(data.height));
    });
}

function getVideoMetaData(videoId, callback) {
    bbApiCallWithCallback('GetVideoMetaData', {videoId:videoId}, function(data) {
        data = JSON.parse(data).info;
        callback(data);
    });
}

function expirePenalty(penaltyType) {
    $.get("/app/api/api.php?method=expirePenaltyForUser&type=" + penaltyType)
        .done(function(){
            window.location.reload();
        });
}

// TODO: Believe this can be removed, but check video class recorderEmbedHtmlParagon
function uploadInputCaptureVideo() {

    $('#flashContent').slideUp();
    $('#tinyMessage').text('Uploading Video...');

    if (typeof beforeUploadInputCapture == 'function') {
        beforeUploadInputCapture();
    }

    var $mobileVideoCaptureForm = $('#mobileVideoCaptureForm');
    if ($mobileVideoCaptureForm.length == 0) {
        $mobileVideoCaptureForm = $('<form></form>')
            .append($('#flashContent').find('input[type=hidden]'))
            .append($('#flashContent').find('input[type=file]'));
    }
    var formData = new FormData($mobileVideoCaptureForm[0]);
    $.ajax({
        url: '/app/api/api.php',
        type: 'POST',
        xhr: function() {  // custom xhr
            var myXhr = $.ajaxSettings.xhr();
            if(myXhr.upload){ // check if upload property exists
                myXhr.upload.addEventListener('progress', uploadInputCaptureVideoProgress, false);
            }
            return myXhr;
        },
        beforeSend: function(){
            $('.progress_container').show();
        },
        // Form data
        data: formData,
        cache: false,
        contentType: false,
        processData: false
    })
        .done(function(e) {
            $('.progress_container').hide();
            if(typeof reportVideoRecorded == 'function') {
                reportVideoRecorded('mobilecapture', 'all good');
            } else {
                alert('Missing ReportVideoRecorded function...');
            }

            //$.notify.success('Video Uploaded', 'captureupload');
        })
        .fail(function(e) {
            //$.notify.failure('Video Upload Failed', 'captureupload');
            console.log(e);
            alert('Video Upload Failed');
        });
}

function uploadInputCaptureVideoProgress(e){
    if(e.lengthComputable){
        var perc = Math.ceil((e.loaded / e.total)*100);
        $('.progress').css('width', perc + '%');
    }
}

function shareUrl(url, title, id) {
    var urlText = '/app/?module=emails&page=shareUrl&popup=1&url=';
    if (id) {
        urlText = '/app/?module=emails&page=shareUrl&popup=1&emailId=' + id + '&url=';
    }

    bbPopup(urlText
        + encodeURIComponent(url)  + '&title=' + encodeURIComponent(title), 420, 280);
}

function AddAssetToClientGroup(clientGroupId, assetType, assetId) {
    if (clientGroupId == -1) return;

    $.notify.progress('Adding this ' + assetType + ' to the group...', 'cgadd');

    var params = {
        clientGroupId: clientGroupId,
        assetType:assetType,
        assetId: assetId
    };

    bbApiCallWithCallback('AddAssetToClientGroup', params, function(data) {
        console.log(data);
        var parsedData = $.parseJSON(data);

        if (parsedData.status == 'success'){
            $.notify.info(parsedData.info + ' Refreshing...', 'cgadd');
            window.location.href = window.location.href;
        } else {
            $.notify.failure(parsedData.info, 'cgadd');
        }

    }, function (error) {
        var parsedData = $.parseJSON(error);

        $.notify.failure(parsedData.info, 'cgadd');
    });
}

function undeployClientGroupAsset(assetId, groupId, assetType) {
    if (confirm('Are you sure you\'d like to delete your users\' copy? Copies that have been sent won\'t be deleted.')) {
        $.notify.progress('Deleting users\' Copies', 'cgdelete'+groupId);
        bbApiCallWithCallback('UndeployFromGroup', {assetId: assetId, assetType: assetType, clientGroupId: groupId, mime: 'json'}, function(response) {
            if (response.status == 'success') {
                $.notify.success(response.info, 'cgdelete'+groupId);
            } else {
                $.notify.failure(response.info, 'cgdelete'+groupId);
            }
        }, function(e) {
            console.log(e);
            var response = JSON.parse(e);
            if (response.hasOwnProperty('info')) {
                $.notify.failure('Something didn\'t go quite right. '+response.info, 'cgdelete'+groupId);
            } else {
                $.notify.failure('Something didn\'t go quite right. Please try again or contact support.', 'cgdelete'+groupId);
            }
        });
    }
}

function undeployAndRemoveClientGroupAssetFromAll(assetId, assetType) {
    if (confirm('Really remove this asset from ALL client groups and DELETE ALL user copies?')) {
        $.notify.progress('Removing from group', 'cgdeleteall');
        bbApiCallWithCallback('UndeployAndRemoveAsset', {assetId: assetId, assetType: assetType, mime: 'json'}, function(response) {
            if (response.status == 'success') {
                $.notify.success(response.info, 'cgdeleteall');
                window.location.reload();
            } else {
                $.notify.failure(response.info, 'cgdeleteall');
            }
        }, function(e) {
            console.log(e);
            var response = JSON.parse(e);
            if (response.hasOwnProperty('info')) {
                $.notify.failure('Something didn\'t go quite right. '+response.info, 'cgdeleteall');
            } else {
                $.notify.failure('Something didn\'t go quite right. Please try again or contact support.', 'cgdeleteall');
            }
        })
    }
}

function PopUpEmailPreview(emailId) {
    bbPopup('/app/index.php?module=emails&page=view_preview&nohtml=1&popup=1&id=' + emailId, 750, '90%');
}

function isOnMobileDevice() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
}

function displayEmailVerificationTools(callParent) {
    var call = '';
    if (callParent) call = '&callParent=1';
    var url = app_url + "?module=users&page=verify_emails&popup=1" + call;
    url = url.replace('http:', '').replace('https:', '');

    responsiveIframePopup(url, 'email-verify');
}

var verifiedEmailCountLastCheck = -1;
function callbackOnEmailIsVerified(callback) {
    var interval = setInterval(function() {
        bbApiCallWithCallback('getUserVerifiedEmails', [], function(response) {
            var json = $.parseJSON(response);
            var verifiedEmails = json.info;
            var numVerifiedNow = verifiedEmails.length;
            if (verifiedEmailCountLastCheck != -1 && verifiedEmailCountLastCheck != numVerifiedNow) {
                callback(verifiedEmails);
            }
            verifiedEmailCountLastCheck = numVerifiedNow;
        });
    }, 2000);
                                        //can run for a max of 10 minutes
    setTimeout(function() {clearInterval(interval)}, 1000*60*10);
    return interval;
}



function redrawFromAddressesSelectingNewAddress(fromAddressSelectId, newAddresses) {

    var fromEmailSelect = $("#" + fromAddressSelectId);
    var existingAddresses = [];

    var existingDdlChildren = document.getElementById(fromAddressSelectId).children;

    for (var i = 0; i<existingDdlChildren.length;i++) {
        var email = existingDdlChildren[i].value;
        if (!valid_email(email)) {
            continue;
        }
        existingAddresses.push(email);
    }

    for (var index in newAddresses) {
        var address = newAddresses[index];
        if ($.inArray(address, existingAddresses) == -1 && valid_email(address)) {
            fromEmailSelect.append("<option>" + address + "</option>").val(address);
            return;
        }
    }

}


function checkFromAddressChange(input_id, fromAddress){
    if (fromAddress == 0) {
        displayEmailVerificationTools();

        var interval = callbackOnEmailIsVerified(function(newEmailList){
            redrawFromAddressesSelectingNewAddress(input_id, newEmailList);
            clearInterval(interval);
        });

    }
}

function checkIfFromHasNoOptions(input_id, fromAddress) {
    if (fromAddress == '0') {
        var select = document.getElementById(input_id);
        if (select.children.length == 1) {
            checkFromAddressChange(input_id, fromAddress);
            return;
        }

        setTimeout(function(){
            if (document.getElementById(input_id).value == '0') {
                checkFromAddressChange(input_id, fromAddress);
            }
        }, 2000);
    }
}

function setWelcomeMessageCookie(clientGroupId)
{
    var cookieValue = "wm_last_seen_" + clientGroupId + "='" + new Date().toLocaleDateString() + "'";
    document.cookie = cookieValue;
}

function setWelcomeLoginCookie()
{
    var cookieValue = 'wm_onlogin_seen=hide';
    document.cookie = cookieValue;
}

/**
 * @deprecated use URLSearchParams instead
 */
function getURLParameter(name) {
    return decodeURI(
        (RegExp(name + '=' + '(.+?)(&|$)').exec(location.search)||[,null])[1]
    );
}

function displayQuickSenderFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var email = params.get('quicksendto');
    if (!email) {
        email = '';
    }
    var videoIdParam = params.get('quicksendvideoid');
    if (!videoIdParam) {
        videoIdParam = '';
    }
    var videoId = videoIdParam === "null" ? '' : videoIdParam;
    if (valid_email(email)) {
        var subjectParam = params.get('quicksendsubject');
        var messageParam = params.get('quicksendmessage');
        var subject = subjectParam === "null" ? '' : subjectParam;
        var message = messageParam === "null" ? '' : messageParam;
        window.postMessage({ type: 'openQuickSender', payload: { to: [email], videoId: videoId, sendAlreadyRecordedVideo: videoId !== '', subject: subject, message: message}})
    } else if(videoId) {
        window.postMessage({ type: 'openQuickSender', payload: { videoId: videoId, sendAlreadyRecordedVideo: true }});
    }
}

function isYouTubeUrl(url) {
    return url.match(/(youtube.com|youtu.be)/);
}

function isAnimotoUrl(url) {
    return url.match(/(animoto.com)/);
}

function getExternalVideoDetails(url) {
    var id, video_type, thumb_url;

    if (isYouTubeUrl(url)) {
        id = getYoutubeVidId(url);
        thumb_url = 'http://img.youtube.com/vi/' + id + '/hqdefault.jpg'
        video_type = "youtube_video";
    }
    else if (isAnimotoUrl(url)) {
        id = getAnimotoVideoId(url);
        thumb_url = "https://s3.amazonaws.com/s3-p.animoto.com/Video/" + id + "/cover_648x360.jpg";
        video_type = "animoto_video";
    }

    return { id: id, video_type: video_type, thumb_url: thumb_url }
}

function getAnimotoVideoId(url) {
    return url.replace(/.+animoto.com\/play\//, "");
}

function cleanYoutubeURL(url) {
    var yt_url = url;
    var cleaned_url = url;

    //If it's in a format like http://www.youtube.com/watch?v=lz8aU1EXkBA&feature=g-vrec
    if (yt_url.indexOf('v=') != -1) {
        var ampersandPosition = yt_url.indexOf('&');
        if (ampersandPosition != -1) {
            cleaned_url = yt_url.substring(0, ampersandPosition);
        }
    }
    return cleaned_url;
}

function getYoutubeVidId(url){
    var yt_url = cleanYoutubeURL(url);
    var video_id;

    //http://www.youtube.com/watch?v=lz8aU1EXkBA&feature=g-vrec
    if (yt_url.indexOf('v=') != -1) {
        video_id = yt_url.split('v=')[1];
    }

    //In cases where the URL is https://youtu.be/OZScqcKFK_E
    if (yt_url.indexOf('youtu.be') != -1) {
        video_id = yt_url.split('/')[3];
    }

    if (video_id == '') return;

    return video_id;

}

function buildRemoveClientFromClientGroupApiUrl(userId, cgId, removeAllContent) {
    var params = new URLSearchParams({ cgId: cgId, userId: userId, removeContent: removeAllContent, method: 'RemoveClientFromGroup' });
    return '/app/api/api.php?' + params.toString();
}

var adCooldownKey = 'bbAdCooldown';
function BBAdInit() {

    if (getCookie(adCooldownKey) == 'active') {
        return;
    }

    bbApiCallWithCallback('GetAdsForUser', {}, function(data) {
        var ads = $.parseJSON(data);
        ads = ads.info;
        if(ads.length > 0) {
          console.log(ads);
        }

        for(var i = 0; i<ads.length;i++) {
            var ad = ads[i];
            if (getCookie('bbAd_' + ad.id) != 'closed') {
                ad.iframeUrl ? showAdPopup(ad) : showAdImage(ad);
                break;
            }
        }

        setCookie(adCooldownKey, 'active', 1);
    });
}

function showAdPopup(ad) {
    bbApiCall('IncrementAdValue', {adId: ad.id, property:'view'});

    responsiveIframePopup(ad.iframeUrl, ad.iframeClass);

    window.onhashchange = function markAdClosed() {
        if (window.location.hash === '#close' || window.location.hash === '#/close')
        {
            bbApiCall('IncrementAdValue', {adId: ad.id, property: 'dismiss'});
            BBAdMarkClosed(ad.id);
            $("body").removeClass("bb-responsive-modal-open");
            window.onhashchange = null;
        }
    };
}

function showAdImage(ad) {
    var popup = $("<a target='_blank'></a>")
        .addClass('bbAdvertisement')
        .attr('href', ad.linkUrl)
        .data('adId', ad.id)
        .click(function(){
            bbApiCall('IncrementAdValue', {adId: ad.id, property:'click'});
            BBAdMarkClosed(ad.id);
        });

    var img = $("<img src='" + ad.imgUrl + "' />").on('load', function() {
        var adHeight = this.height;
        var adWidth = this.width;
        var adTop = ($(window).height()/2) - (adHeight/2);
        var adLeft = ($(window).width()/2) - (adWidth/2);

        if (adHeight > $(window).height() || adWidth > $(window).width()) {
            img.css('maxHeight', $(window).height());
            img.css('maxWidth', $(window).width());
            adWidth = $(window).width();
            adTop = 35;
            adLeft = 0;
        }

        popup.css('left', adLeft).animate({
            top: adTop,
            left: adLeft
        }, 600, function(){

            bbApiCall('IncrementAdValue', {adId: ad.id, property:'view'});

            var closeButton = $("<div class='bbAdvertisement' style='cursor:pointer;'><img src='/app/images/modules/onboarding/icon-close.svg'></div>").click(function(){
                bbApiCall('IncrementAdValue', {adId: ad.id, property:'dismiss'});
                BBAdMarkClosed(ad.id);
            }).hide().appendTo('body');

            var closeButtonSize = 35;
            closeButton.hide()
                .css({
                    top: adTop - closeButtonSize,
                    left: adLeft + adWidth - closeButtonSize
                }).fadeIn();

        });
    });

    popup.append(img);
    popup.appendTo('body');
}

function BBAdMarkClosed(adId) {
    setCookie('bbAd_'+adId, 'closed', 24*30);
    $('.bbAdvertisement').fadeOut(200, function() {
        $(this).remove();
    });
}

function setCookie(key, value, hoursToLive) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (hoursToLive * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';secure';
}

function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}

// TODO: delete if ce_auto_login is not used (see unused code logs and check if ce_auto_login is still in the repo)
function startTryingToLogChromeExtensionIn()
{
    $("<iframe src='/app/index.php?module=users&page=ce_auto_login&nohtml=1' hidden></iframe>").appendTo("body");
};

function closeSidebar(){
    if ($(window).width() < 960) {
        $('.standard-2-columns').addClass('sidebar-closed');
    }

    $( ".toggle-sidebar" ).click(function() {
        $( ".standard-2-columns" ).toggleClass( "sidebar-closed", 200 );
    });
}

function getMicroFrontEnd(localUrl, url) {
    var headerMap = {};
    var environment = guessEnvironment();
    var scriptUrl = url;

    function handleReadyState() {
        if(this.readyState == this.HEADERS_RECEIVED) {
            // Create a map of header names to values
            var arr = request.getAllResponseHeaders().trim().split(/[\r\n]+/);
            arr.forEach(function (line) {
                var parts = line.split(': ');
                var header = parts.shift();
                var value = parts.join(': ');
                headerMap[header] = value;
            });
            insertScript();
        }
    }

    function handleError(error) {
        insertScript();
    }

    function insertScript() {
        // if local server responded with a script use that
        if(headerMap && headerMap["content-type"]
            && headerMap["content-type"].indexOf("application/javascript") > -1) {
            scriptUrl = localUrl;
        }

        var appScript = document.createElement("script");
        appScript.setAttribute("src", scriptUrl);
        document.head.appendChild(appScript);
    }

    if (environment === 'LOCAL') {
        var request = new XMLHttpRequest();
        request.onerror = handleError;
        request.onreadystatechange = handleReadyState;
        request.open('get', localUrl, true);
        request.send();

    } else {
        insertScript();
    }
}

function getPreconfiguredMicroFrontEnd(name) {
    var config = window[name.toLowerCase()];
    getMicroFrontEnd(config.localUrl, config.url);
}
